//申请功能
export const applyRouter=[
    {
        path: '/',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/applyList'),
    },
    {//申请管理
        path: '/applyList',
        name:'applyList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/applyList'),
    },
    {//新建病历
        path: '/applyForm',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/applyForm'),
    },
    {//重新申请病历
        path: '/reApply',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/reApply'),
    },
    {//上传心电文件
        path: '/uploadFile',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/uploadFile'),
    },
    {//上传心电文件
        path: '/reUpload',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/reUpload'),
    },
    {//选择医院
        path: '/selectHosp',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/selectHosp'),
    },
    {//确认订单
        path: '/detminOrder',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/detminOrder'),
    },
    {//支付
        path: '/order',
        component: () => import(/* webpackChunkName: 'home' */ '../page/apply/order'),
    },
]
//诊断功能
export const diagRouter=[
    {//诊断管理
        path: '/diagnList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/diagn/diagnList'),
    },
    {//病历详情
        path: '/formDetail',
        component: () => import(/* webpackChunkName: 'home' */ '../page/diagn/formDetail'),
    },
]
//管理员功能
export const adminRouter=[
    {//医院管理
        path: '/hospAdmin',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/hospAdmin'),
    },
    {//下级医院列表页
        path: '/upHospList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/upHospList'),
    },
    {//医生管理
        path: '/docAdmin',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/docAdmin'),
    },
    {//交易记录
        path: '/recordList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/recordList'),
    },
    {//充值付款页面
        path: '/accOrder',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/accOrder'),
    },
]
//统计员
export const stateRouter=[
    {//全院病例
        path:'/allCase',
        component: () => import(/* webpackChunkName: 'home' */ '../page/static/allCase'),
    }
]
//通用
export const commonRouter=[
    {//个人中心
        path: '/personal',
        component: () => import(/* webpackChunkName: 'home' */ '../page/personal'),
    }
]


// WEBPACK FOOTER //
// ./src/router/routerTable.js